/* Initial number of rows to load for a table */
export const INITIAL_LOAD_ROW_COUNT = 25;

/* Initial number of rows to load for a table built locally (i.e. Priority View, Catch Up views) */
export const INITIAL_LOAD_ROW_COUNT_LOCAL_TABLE = 300;

/* Initial number of rows to load for Headlines view */
export const INITIAL_LOAD_ROW_COUNT_FOR_HEADLINES = 50;
